module.exports = __webpack_public_path__ + "static/media/mk-MK.2e549b6c.md";